"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("@/store/ducks/users/selectors");
const users_1 = require("@/store/ducks/users");
const index_view_1 = __importDefault(require("./index.view"));
function UsersToast() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const userToastStatus = (0, react_redux_1.useSelector)(selectors_1.usersToastStatusSelector);
    react_1.default.useEffect(() => {
        let close = undefined;
        if (userToastStatus?.isOpen) {
            close = setInterval(() => {
                dispatch((0, users_1.closeUserToast)());
            }, 3000);
        }
        return () => clearInterval(close);
    }, [userToastStatus?.isOpen, userToastStatus, dispatch]);
    const onClose = react_1.default.useCallback((event, reason) => {
        if (reason === "clickaway") {
            dispatch((0, users_1.closeUserToast)());
        }
    }, [users_1.closeUserToast, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: Boolean(userToastStatus?.isOpen), onClose: onClose, severity: userToastStatus?.status, anchorOrigin: { horizontal: "right", vertical: "top" }, message: userToastStatus?.message }));
}
exports.default = UsersToast;
